"use client"

import React from "react"

import BackButton from "./BackButton"
import NeloLogo from "./NeloLogo"

interface NavBarProps {
  showBackButton?: boolean
  onBack?: () => void
}

const NavBar: React.FC<NavBarProps> = ({ showBackButton = false, onBack }) => {
  return (
    <div className="flex items-center py-4">
      {showBackButton && onBack && <BackButton onClick={onBack} />}
      <NeloLogo />
      {showBackButton && <div className="w-14"></div>}
    </div>
  )
}

export default NavBar
